export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-title">GOAT ★ PACEVILLE ★ MALTA</p>
      <p className="footer-sub">Greatest of All Tapas · @GOATBAR.MALTA · 12PM–3AM Daily</p>
    </footer>
  )
}
